import cn from "classnames";
import React from 'react';
import "./style.css";
import { Checkmark } from '../../../icons';

const colorMap = {
  open: '#2D8EFF',
  'in-progress': '#FF9900',
  complete: '#FFFFFF',
  deferred: '#EB0000'
}

const TaskIcon = ({
  status
}) => (
    <div className={cn("task-icon", status)}>
      <Checkmark color={colorMap[status]} />
    </div>
  );

export default TaskIcon;



// WEBPACK FOOTER //
// ./src/components/TaskListItem/TaskIcon/index.js